import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ShareableLinksApiService } from '../../sharing/links/shareable-links-api.service';
import { BehaviorSubject } from 'rxjs';
import { PreviewFilesService } from 'common/file-preview/preview-files.service';
import { Settings } from 'common/core/config/settings.service';
import { CurrentUser } from 'common/auth/current-user';
import { filter, map } from 'rxjs/operators';
import { Toast } from 'common/core/ui/toast.service';
import { Store } from '@ngxs/store';
import { DownloadEntries } from '../../state/actions/commands';
var LinkPreviewContainerComponent = /** @class */ (function () {
    function LinkPreviewContainerComponent(store, route, links, previewFiles, settings, currentUser, router, toast) {
        this.store = store;
        this.route = route;
        this.links = links;
        this.previewFiles = previewFiles;
        this.settings = settings;
        this.currentUser = currentUser;
        this.router = router;
        this.toast = toast;
        this.link$ = new BehaviorSubject(null);
        this.entries$ = new BehaviorSubject([]);
        this.passwordPanelVisible$ = new BehaviorSubject(false);
    }
    Object.defineProperty(LinkPreviewContainerComponent.prototype, "entryAlreadyImported$", {
        /**
         * Check if current user owns this entry or
         * already has it imported into their drive.
         */
        get: function () {
            var userId = this.currentUser.get('id');
            return this.link$.pipe(filter(function (link) { return !!link && !!link.entry && !!link.entry.users; }), map(function (link) { return link.entry; }), map(function (entry) { return !!entry.users.find(function (user) { return user.id === userId; }); }));
        },
        enumerable: true,
        configurable: true
    });
    LinkPreviewContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.bindToDownload();
        this.route.params.subscribe(function (params) {
            _this.links.findByHash(params.hash, { withEntries: true }).subscribe(function (response) {
                _this.link$.next(response.link);
                if (_this.link$.value.password) {
                    _this.togglePasswordPanel(true);
                }
                else {
                    _this.togglePasswordPanel(false);
                    _this.showPreview();
                }
            }, function () {
                _this.router.navigate(['/404']);
            });
        });
    };
    LinkPreviewContainerComponent.prototype.ngOnDestroy = function () {
        this.downloadSub.unsubscribe();
    };
    LinkPreviewContainerComponent.prototype.import = function () {
        var _this = this;
        this.links.importEntry(this.link$.value.id, this.password)
            .subscribe(function (response) {
            var link = _this.link$.value;
            link.entry.users = response.users;
            _this.link$.next(link);
            _this.toast.open("\"" + link.entry.name + "\" imported into your drive.");
        });
    };
    LinkPreviewContainerComponent.prototype.togglePasswordPanel = function (value) {
        this.passwordPanelVisible$.next(value);
    };
    LinkPreviewContainerComponent.prototype.bindToDownload = function () {
        var _this = this;
        this.downloadSub = this.previewFiles.download.subscribe(function () {
            var link = _this.link$.value;
            _this.store.dispatch(new DownloadEntries([link.entry], link, _this.password));
        });
    };
    /**
     * Show preview for shareable link files.
     */
    LinkPreviewContainerComponent.prototype.showPreview = function () {
        var link = this.link$.value;
        this.previewFiles.setPreviewUriTransformer(this.urlTransformer.bind(this));
        this.setEntries(link.entry);
    };
    /**
     * Set all preview entries.
     */
    LinkPreviewContainerComponent.prototype.setEntries = function (entry) {
        var entries = entry.children.length ? entry.children : [entry];
        entries = entries.filter(function (ent) { return ent.type !== 'folder'; });
        this.entries$.next(entries);
    };
    LinkPreviewContainerComponent.prototype.setValidPassword = function (password) {
        this.showPreview();
        this.togglePasswordPanel(false);
        this.password = password;
    };
    LinkPreviewContainerComponent.prototype.urlTransformer = function (entryId) {
        var base = "secure/uploads/" + entryId + "?shareable_link=" + this.link$.value.id;
        if (this.password)
            base += "&password=" + this.password;
        return base;
    };
    return LinkPreviewContainerComponent;
}());
export { LinkPreviewContainerComponent };
